import  { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
// import { DataGrid } from '@mui/x-data-grid';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { useGetUserMetricsQuery, useGetTransactionDetailsQuery } from '../../../services/PaymentToolApi';
import { formatMoney } from '../../../utils';
import { parseToEasternTime, eventDatesFormatter } from '../../../utils/dates';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useLocation, useHistory } from "react-router-dom";
import { Grid, IconButton, Button} from '@mui/material';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../../features/auth/authSlice';

function getDefaultsValues(searchParams) {

  return {
    pageNumber: Number(searchParams.get("pageNumber")) || 1,
    pageSize: Number(searchParams.get("pageSize")) || 100,
  }
}

export default function HoneypotTable({ selectedPeriod, selectedYear }) {
  const location = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);

  const { pageNumber: numberDftl, pageSize: sizeDftl } = getDefaultsValues(searchParams);

  const [pageNumber, setPageNumber] = useState(numberDftl);
  const [pageSize, setPageSize] = useState(sizeDftl);

  useEffect(() => {
    // searchParams.set("tab_index", 2); //A: this is the index of the tab in the admin tools
    searchParams.set("pageNumber", pageNumber);
    searchParams.set("pageSize", pageSize);

    history.push(`/dashboard/home?${searchParams.toString()}`);
  }, [pageNumber, pageSize, history]);

  const user= useSelector(selectCurrentUser);

  const { data: userMetrics, error: userMetricsError, isLoading: userMetricsLoading, isFetching: userMetricsIsFetching } = useGetUserMetricsQuery({
    userId: user.id,
    year: selectedYear,
    period: selectedPeriod,
    pageSize: pageSize,
    pageNumber: pageNumber,
  });

  function NotesForAdminToolTip({params}){

    console.log("NotesForAdminToolTip row: " , params.row);
    let text= "";
    
    if (params.row.transactionType === "Penalty") {
      //A: if errorReason is "Other" we show only the notesForBee, otherwise we show the errorReason and notesForBee
      text = params.row.errorReason !== "Other" 
        ? params.row.errorReason + (params.row.notesForBee ? ", " + params.row.notesForBee : "")
        : (params.row.notesForBee || "N/A");
    } else {
      text = params.row.notesForBee || "N/A";
    }

    return (
      <Tooltip title={text} placement="top-start">
        <IconButton
          sx={{ margin: "0" }}
          color="primary"
        >
          <InfoOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    );
  }

  const CustomWidthTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: 'none',
    },
  });

  function EventInformationToolTip({ params }) {
    const [triggerGetTransactionDetails, setTriggerGetTransactionDetails] = useState(false);
    const [text, setText] = useState("Loading..."); 

    const handleMouseEnter = () => {
      setTriggerGetTransactionDetails(true);
    };

    const {
      data: transactionDetails, 
      isLoading: transactionDetailsIsLoading, 
      error: transactionDetailsError} = useGetTransactionDetailsQuery({transactionID: params.row.transactionID, fields: ['orderNumber', 'venueName', 'eventdate']}, {skip: !triggerGetTransactionDetails});

      useEffect(() => {
        if (transactionDetails) {
          let text =
            "Venue Name: " + transactionDetails.venueName + "\n" +
            "Event Date: " + eventDatesFormatter(transactionDetails.eventDate,  { showWeekday: false }) + "\n" +
            "Order Number: " + transactionDetails.orderNumber;
          setText(text);
        }
      }, [transactionDetails]);

    return (
      <CustomWidthTooltip  
        title={
          <span style={{ whiteSpace: 'pre-line' }}>
            {text}
          </span>
        } 
        placement="top-start" 
        onMouseEnter={handleMouseEnter}
      >
          <Button style={{color:'black'}}>{params.row.eventName}</Button>
      </CustomWidthTooltip >
    );
  }
  
  const columns = [
    {
      field: 'transactionID',
      headerName: 'TRANSACTION ID',
      flex: 0.75,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'date',
      headerName: 'DATE',
      flex: 1, 
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => parseToEasternTime(params.row.date),
    },
    {
      field: 'eventName',
      headerName: 'EVENT NAME',
      flex: 1,    
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => params.row.eventName || '-',
      renderCell: (params) => {
        if(!params.row.eventName) return "-";

        return (
          <EventInformationToolTip params={params} />
        );
      }
    },
    {
      field: 'buyType',
      headerName: 'BUY TYPE',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => params.row.buyType || '-',
    },
    {
      field: 'transactionType',
      headerName: 'TRANSACTION TYPE',
      //THIS WIDTH IS IMPORTANT, THIS ALLOR TO SHOW ROWS WITH PERFECT ALIGNMENT BETWEEN THE TEXT AND ICON
      width: 126,
      headerAlign: 'center',
      align: 'left',
      renderCell: (params) => {
        let text= params.row.transactionType == "Penalty" ? "Error" : params.row.transactionType;

        const color = {
          Reward: "green",
          Penalty: "red",
          Deduction: "orange",
          Bonus: "green",
          Royalty: "green",
        }[params.row.transactionType] || "black";

        return (
          <Grid container alignItems="center" justifyContent="space-between" wrap='nowrap'>
            <Grid item style={{ color, fontWeight: "600" }}>
              {text.trim()}
            </Grid>
            <Grid item sx={{ marginLeft: 'auto' }}>
              <NotesForAdminToolTip params={params} />
            </Grid>
          </Grid>
        );
      }
    },
    {
      field: 'relatedTransactionID',
      headerName: 'RELATED TRANSACTION',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => params.row.relatedTransactionID || '-',
    },
    {
      field: 'reward',
      headerName: 'REWARD',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => params.row.reward,
    },
    {
      field: 'amount',
      headerName: 'AMOUNT',
      flex: 1, 
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        const formattedAmount = formatMoney(params.row.amount || 0);
        const transactionType = params.row.transactionType;
        if (transactionType === "Penalty" || transactionType === "Deduction") {
         return <p style={{ color: 'red' }}> -{formattedAmount}</p>;
        } else {
          return <p>{formattedAmount}</p>
        }
      },
    },
  
  ];

  function iconStyle(){
    return {
      margin: " 0 0 0 0.25em ",
      fontSize: "20px"
    }
  }

  const IconInfo = ({reason, transactionType}) => {
    return (
      transactionType === "Reward" && !reason ?//A: if the transaction type is reward and there is no reason, we dont show the icon
       null
        :
        <Tooltip title={reason} placement="top-start">
          <InfoOutlinedIcon sx={iconStyle()} />
        </Tooltip>
    )
  }

  function onPaginationChangeHandler(model) {
    console.log(model)
    const { page, pageSize: newPageSize } = model;
    console.log(pageSize)
    if (newPageSize != pageSize) setPageSize(newPageSize);
    console.log(pageSize)
    let pageGridFixed = page + 1;
    if (pageGridFixed != pageNumber) {
      setPageNumber(pageGridFixed)
    }
  }
  return (
    <Box sx={{
      height: "65vh",
      width: '100%',
      '& .MuiDataGrid-row': {
        borderBottom: '2px solid #f2f2f2',
      },
    }}
    >
       <DataGridPremium
        sx={{ borderRadius: "0 0 1em 1em", backgroundColor: 'white', padding: '0 1em', '& .MuiBadge-badge': { display: 'none' }, }}
        headerHeight={40}
        rowHeight={36}
        loading={userMetricsLoading || userMetricsIsFetching}
        rows={(userMetrics?.items || []).slice().sort((a, b) => a.transactionID - b.transactionID)}
        getRowId={row => row.transactionID}
        columns={columns}
        disableRowSelectionOnClick
        pagination
        paginationMode="server"
        rowCount={userMetrics?.totalCount || 0}
        onPaginationModelChange={onPaginationChangeHandler}
        page={pageNumber - 1} //A: the pagination starts in 0, but the api starts in 1
        pageSize={pageSize}
        initialState={{
          pagination: { paginationModel: { pageSize: pageSize, page: pageNumber - 1 } }, //A: the pagination starts in 0, but the api starts in 1
        }}
      />
    </Box>
  );
}
